import React, { useState } from 'react';
import './ResetareProgres.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRotateLeft,
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

const ResetareProgres = ({ onResetProgress }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [message, setMessage] = useState('');

  const handleReset = async () => {
    try {
      setIsResetting(true);
      setMessage('');

      if (onResetProgress) {
        await onResetProgress();
      }

      setMessage('Progresul a fost resetat cu succes.');
      setShowConfirm(false);
    } catch (error) {
      console.error('Eroare la resetarea progresului:', error);
      setMessage('Progresul nu a putut fi resetat.');
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <div className="resetare-progres">
      <div className="resetare-progres__header">
        <div className="resetare-progres__icon">
          <FontAwesomeIcon icon={faRotateLeft} />
        </div>

        <div>
          <h4 className="resetare-progres__title">
            Resetare progres
          </h4>

          <p className="resetare-progres__description">
            Sterge progresul lectiilor, quiz-urilor si aplicatiilor finalizate.
          </p>
        </div>
      </div>

      {!showConfirm && (
        <button
          type="button"
          className="resetare-progres__button"
          onClick={() => {
            setShowConfirm(true);
            setMessage('');
          }}
        >
          <FontAwesomeIcon icon={faRotateLeft} />
          <span>Reseteaza progresul</span>
        </button>
      )}

      {showConfirm && (
        <div className="resetare-progres__confirm">
          <div className="resetare-progres__warning">
            <FontAwesomeIcon icon={faTriangleExclamation} />

            <p>
              Esti sigur ca vrei sa resetezi progresul? Aceasta actiune nu
              poate fi anulata.
            </p>
          </div>

          <div className="resetare-progres__actions">
            <button
              type="button"
              className="resetare-progres__cancel"
              onClick={() => setShowConfirm(false)}
              disabled={isResetting}
            >
              Anuleaza
            </button>

            <button
              type="button"
              className="resetare-progres__confirm-button"
              onClick={handleReset}
              disabled={isResetting}
            >
              {isResetting ? 'Se reseteaza...' : 'Confirma resetarea'}
            </button>
          </div>
        </div>
      )}

      {message && (
        <p className="resetare-progres__message">
          {message}
        </p>
      )}
    </div>
  );
};

export default ResetareProgres;